import { PlaylistConstant } from '../_constants';

const initialState = {
  CreatedOn:null,
  Description:null,
  PlaylistId:null,
  Title:null,
  VideoCount:0
};
export function playlist(state = {}, action) {
  switch (action.type) {
    case PlaylistConstant.GETALL_REQUEST:
      return {
        loading: true
      };
    case PlaylistConstant.GETALL_SUCCESS:
      return {
        playlist: action.playlist
      };
    case PlaylistConstant.GETALL_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/playlist.reducer.js